export class CustomEventNewCardEnt{
    id?: string;
    image?:string;
    title?:string;
    content?:string;
    eventDate?: Date;
    tags?:string[];
    url?: string;
    route?: string;
    createdAt?: Date;
    updatedAt?: Date;
    type?: string;
}
